import { create } from "zustand";

import { SearchRequest } from "../api/pps";

export interface SearchState {
  omneId: string;
  signUpCountry: string[];
}

type State = SearchState;

type Actions = {
  actions: {
    setState: (state: SearchState) => void;
  };
};

const SearchStore = create<State & Actions>(set => ({
  // State
  omneId: "",
  signUpCountry: [],

  // Actions
  actions: {
    setState: newState =>
      set(() => ({
        ...newState,
      })),
  },
}));

export const useSearchStore = () => {
  return SearchStore(store => ({
    omneId: store.omneId,
    signUpCountry: store.signUpCountry,
  }));
};

export const useSetSearchStore = () => {
  return SearchStore(store => store.actions.setState);
};

type queryState = SearchRequest;

type ActionsQuery = {
  actions: {
    setQueryString: (queryString: SearchRequest) => void;
  };
};

const QuerySearchStore = create<queryState & ActionsQuery>(set => ({
  // State
  omneId: "",
  signUpCountry: "",
  pagination: {
    currentPage: 1,
    pageSize: 12,
  },
  permission_Token: "",

  // Actions
  actions: {
    setQueryString: queryString =>
      set(() => ({
        ...queryString,
      })),
  },
}));

export const useSearchQuery = () =>
  QuerySearchStore(store => ({
    queryString: {
      omneId: store.omneId,
      signUpCountry: store.signUpCountry,
      pagination: {
        currentPage: store.pagination.currentPage,
        pageSize: store.pagination.pageSize,
      },
      permission_Token: store.permission_Token,
    },
    setQueryString: store.actions.setQueryString,
  }));
